// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";
import type { RainfallEvents } from "./RainfallEvents";
import {
  RainfallEventsFromJSON,
  RainfallEventsFromJSONTyped,
  RainfallEventsToJSON,
  RainfallEventsToJSONTyped,
} from "./RainfallEvents";

/**
 *
 * @export
 * @interface SimulateRainfallStandardEventsInput
 */
export interface SimulateRainfallStandardEventsInput {
  /**
   *
   */
  rainfallEvent: RainfallEvents;
  /**
   *
   */
  schematisation: RanaFile;
}

/**
 * Check if a given object implements the SimulateRainfallStandardEventsInput interface.
 */
export function instanceOfSimulateRainfallStandardEventsInput(
  value: object
): value is SimulateRainfallStandardEventsInput {
  if (
    (!("rainfallEvent" in (value as Record<string, any>)) &&
      !("rainfall_event" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["rainfallEvent"] === undefined &&
      (value as Record<string, any>)["rainfall_event"] === undefined)
  )
    return false;
  if (!("schematisation" in value) || value["schematisation"] === undefined) return false;
  return true;
}

export function SimulateRainfallStandardEventsInputFromJSON(
  json: any
): SimulateRainfallStandardEventsInput {
  return SimulateRainfallStandardEventsInputFromJSONTyped(json, false);
}

export function SimulateRainfallStandardEventsInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulateRainfallStandardEventsInput {
  if (json == null) {
    return json;
  }
  return {
    rainfallEvent: RainfallEventsFromJSON(json["rainfall_event"]),
    schematisation: RanaFileFromJSON(json["schematisation"]),
  };
}

export function SimulateRainfallStandardEventsInputToJSON(
  json: any
): SimulateRainfallStandardEventsInput {
  return SimulateRainfallStandardEventsInputToJSONTyped(json, false);
}

export function SimulateRainfallStandardEventsInputToJSONTyped(
  value?: SimulateRainfallStandardEventsInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    rainfall_event: RainfallEventsToJSON(value["rainfallEvent"]),
    schematisation: RanaFileToJSON(value["schematisation"]),
  };
}
